import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["height"]


export default /*#__PURE__*/_defineComponent({
  __name: 'IconAlert',
  props: {
    classFill: {},
    size: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    height: _ctx.size || 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    _createElementVNode("path", {
      class: _normalizeClass(_ctx.classFill),
      d: "M10.8333 11.6667H9.16658V7.49999H10.8333V11.6667ZM10.8333 15H9.16658V13.3333H10.8333V15ZM0.833252 17.5H19.1666L9.99992 1.66666L0.833252 17.5Z",
      fill: "#4B5563"
    }, null, 2)
  ], 8, _hoisted_1))
}
}

})